// https://www.figma.com/file/5ydKdZCchAMIWPXhSb6aL9/%F0%9F%94%A4-Font-WEB?node-id=1%3A92

export enum FONTS {
    // Head Desktop (HD)
    H0 = 'font: var(--bold-h0); letter-spacing: 0.01em;',
    H1 = 'font: var(--bold-h1); letter-spacing: 0.01em;',
    H2 = 'font: var(--bold-h2); letter-spacing: 0.01em;',
    H3 = 'font: var(--bold-h3); letter-spacing: 0.01em;',
    H4 = 'font: var(--bold-h4); letter-spacing: 0.01em;',
    H5 = 'font: var(--bold-h5); letter-spacing: 0.01em;',
    H6 = 'font: var(--bold-h6); letter-spacing: 0.01em;',

    // Only for Label
    LABEL = 'font: var(--label); letter-spacing: 0.01em; text-transform: uppercase;',
    LABEL_S = 'font: var(--label-s); letter-spacing: 0.01em; text-transform: uppercase;',

    // Only for Stories
    Stories = 'font: var(--stories); letter-spacing: 0.01em;',
    StoriesS = 'font: var(--stories-s); letter-spacing: 0.01em;',

    // Action Desktop (AD)
    Medium = 'font: var(--medium); letter-spacing: 0.01em;',
    MediumS = 'font: var(--medium-s); letter-spacing: 0.01em;',
    MediumXS = 'font: var(--medium-xs); letter-spacing: 0.01em;',
    MediumXXS = 'font: var(--medium-xxs); letter-spacing: 0.01em;',
    MediumXXXS = 'font: var(--medium-xxxs); letter-spacing: 0.01em;',

    // Text Desktop (TD)
    XXL = 'font: var(--regular-xxl);',
    XL = 'font: var(--regular-xl);',
    L = 'font: var(--regular-l);',
    M = 'font: var(--regular-m);',
    S = 'font: var(--regular-s);',
    XS = 'font: var(--regular-xs);',
    XXS = 'font: var(--regular-xxs);',
    XXXS = 'font: var(--regular-xxxs);',
}
